import { render, staticRenderFns } from "./PastDueRent.vue?vue&type=template&id=acbb2294&scoped=true&"
import script from "./PastDueRent.vue?vue&type=script&lang=js&"
export * from "./PastDueRent.vue?vue&type=script&lang=js&"
import style0 from "./PastDueRent.vue?vue&type=style&index=0&id=acbb2294&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acbb2294",
  null
  
)

export default component.exports